import React from 'react'
import { INewsUpdatesList as IContentfulNewsUpdatesList } from 'marketing-site/@types/generated/contentful'
import { NewsUpdatesList } from 'marketing-site/src/library/elements/NewsUpdatesList'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export const ContentfulNewsUpdatesList = (newsUpdatesList: IContentfulNewsUpdatesList) => (
  <EntryMarker entry={newsUpdatesList}>{() => <NewsUpdatesList />}</EntryMarker>
)
